export default [
  "public",
  "prive"
];
